import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";

function AboutmeComponent() {
    return (
        <Box id="section0" className="section section-about" sx={{ flexGrow: 1, borderRadius: 2, p: 5 }}>

            <Container maxWidth="md" >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Avatar className="avatar" alt="Myriam" src="/images/aboutme-2.jpg" sx={{ width: 250, height: 250 }} />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography component="h2" mb={3}>A propos</Typography>
                        <Typography component="p" mb={5}>
                            Maman de deux enfants, 7 et 5 ans, je suis préparatrice en pharmacie de formation. J'ai arrêté ce métier afin de pouvoir me consacrer entièrement à mes enfants et à ma passion, la création.
                        </Typography>

                        <Button variant="contained" size="large" href="mailto:myriam@tendreconception.fr?subject=Demande de renseignements" >Contactez-moi !</Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default AboutmeComponent;

